import styled from 'styled-components';

import { FilterIcon, SortIcon } from '@components/icons';
import { Caption } from '@components/styles/Typography';

export const FilterButton = ({ title, onFilterModalOpen, filterCount }) => (
    <ModalOpenButton onClick={onFilterModalOpen} type="button" filter>
        <Caption>
            {title}
            {filterCount > 0 && <Caption>({filterCount})</Caption>}
        </Caption>
        <FilterIcon />
    </ModalOpenButton>
);

export const SortButton = ({ title, onSortModalOpen }) => (
    <ModalOpenButton
        onClick={onSortModalOpen}
        type="button"
        data-testid="sort-button"
    >
        <SortIcon />
        <Caption>{title}</Caption>
    </ModalOpenButton>
);

const ModalOpenButton = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    margin: 0;
    text-align: center;
    padding: 8px 0;
    cursor: pointer;

    @media (max-width: 1024px) {
        border-right: ${({ filter }) =>
            filter ? '1px solid #000000;' : 'none'};
        width: 50%;
    }

    span {
        margin: 0 3px;
    }
`;
